import {
    faCheck,
    faLightbulb,
    faPhone,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState, useRef } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import MaskedInput from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import './index.css';

const CalculadoraRPA = () => {
    const sectionRef = useRef(null);

    const [simples, setSimples] = useState(null);
    const [atividade, setAtividade] = useState('');
    const [faturamento, setFaturamento] = useState('');
    const [proLabore, setProLabore] = useState(null);
    const [valorProLabore, setValorProLabore] = useState('');
    const [temFuncionarios, setTemFuncionarios] = useState(null);
    const [gastoFolha, setGastoFolha] = useState('');
    const [resultado, setResultado] = useState(null);

    const [step, setStep] = useState('calculadora');

    const formatarParaReal = (valor) => {
        return Number(valor).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        });
    };

    const currencyMask = createNumberMask({
        prefix: 'R$ ',
        thousandsSeparatorSymbol: '.',
        decimalSymbol: ',',
        allowDecimal: true,
        includeThousandsSeparator: true,
        allowNegative: false,
        integerLimit: 10,
        decimalLimit: 2,
    });

    const limparNumero = (valor) => {
        if (!valor) return 0;

        // Remove tudo que não for número, vírgula ou ponto
        let numeroLimpo = valor.replace(/[^0-9,.-]/g, '');

        // Substitui separadores de milhar por nada e garante que o último separador decimal seja um ponto
        numeroLimpo = numeroLimpo.replace(/\./g, '').replace(/,/, '.');
        return Number(numeroLimpo) || 0;
    };

    const calcularFatorR = () => {
        const faturamentoNum = limparNumero(faturamento);
        const proLaboreNum = limparNumero(valorProLabore);
        const folhaNum = limparNumero(gastoFolha);
        const totalRemuneracao = proLaboreNum + folhaNum;
        const fatorR =
            faturamentoNum > 0 ? (totalRemuneracao / faturamentoNum) * 100 : 0;

        const aliquotaPadrao = 15.5 / 100;
        const aliquotaComFatorR = 6 / 100;
        const economiaMensal =
            faturamentoNum * (aliquotaPadrao - aliquotaComFatorR);
        const economiaAnual = economiaMensal * 12;

        setResultado({
            fatorR: fatorR.toFixed(2),
            economiaAnual: economiaAnual.toFixed(2),
        });
        setStep('resultado');
        sectionRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <>
            <div className="container">
            <Row style={{ marginBottom: '150px' }}>
                <Col sm={12} md={12} lg={8}>
                    <div className="main">
                        <div className="container mt-4 pt-3">
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                }}
                                className="mb-5"
                            >
                                <img
                                    src="https://www.contabilidadeolimpia.com.br/wp-content/uploads/2022/05/logo-contabilidade-olimpia-transparente.png"
                                    width={250}
                                />
                            </div>

                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    textAlign: 'center',
                                    boxSizing: 'border-box',
                                }}
                            >
                                <h2
                                    className="mt-2 text-center mb-2"
                                    style={{
                                        color: '#002868',
                                        marginTop: '15px',
                                        fontSize: '24px', // Tamanho da fonte ajustado
                                    }}
                                >
                                    Calculadora Fator-R Simples Nacional
                                </h2>
                                <p
                                    className="mt-2 text-center mb-5"
                                    style={{
                                        maxWidth: 500,
                                        fontSize: '16px',
                                        lineHeight: '1.5',
                                    }}
                                >
                                    A calculadora Fator R é uma ferramenta para
                                    empreendedores que desejam calcular se é
                                    possível economizar com impostos através da
                                    geração de empregos! Saiba agora se sua
                                    empresa pode aproveitar esta oportunidade!
                                </p>
                            </div>

                            <Form className="text-center">
                                <Row>
                                    <Col md={12}>
                                        <Form.Group controlId="simplesNacional">
                                            <Form.Label>
                                                Sua empresa é optante pelo
                                                Simples Nacional?
                                            </Form.Label>
                                            <div>
                                                <Form.Check
                                                    type="radio"
                                                    label="Sim"
                                                    name="simplesNacional"
                                                    checked={simples === true}
                                                    onChange={() =>
                                                        setSimples(true)
                                                    }
                                                />
                                                <Form.Check
                                                    type="radio"
                                                    label="Não"
                                                    name="simplesNacional"
                                                    checked={simples === false}
                                                    onChange={() =>
                                                        setSimples(false)
                                                    }
                                                />
                                            </div>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className="mt-3">
                                    <Col md={12}>
                                        <Form.Group
                                            controlId="atividade"
                                            className="mb-3"
                                        >
                                            <Form.Label>
                                                Qual a atividade da sua empresa?
                                            </Form.Label>
                                            <Form.Select
                                                value={atividade}
                                                onChange={(e) =>
                                                    setAtividade(e.target.value)
                                                }
                                            >
                                                <option value="locacaoImoveis">
                                                    Administração e locação de
                                                    imóveis de terceiros
                                                </option>
                                                <option value="danca">
                                                    Academia de dança, capoeira,
                                                    ioga, lutas e artes marciais
                                                </option>
                                                <option value="academia">
                                                    Academia ou escola de
                                                    atividades físicas e
                                                    esportes
                                                </option>
                                                <option value="computadores">
                                                    TI e desenvolvedor de
                                                    programas de computadores e
                                                    sites
                                                </option>
                                                <option value="laboratorio">
                                                    Laboratório de análises
                                                    clínicas ou de patologia
                                                    clínica
                                                </option>
                                                <option value="tomografia">
                                                    Serviços de tomografia,
                                                    diagnósticos médicos por
                                                    imagem, ressonância
                                                    magnética, registros
                                                    gráficos e métodos óticos
                                                </option>
                                                <option value="protese">
                                                    Serviços de prótese em geral
                                                </option>
                                                <option value="fisioterapia">
                                                    Fisioterapia
                                                </option>
                                                <option value="medicina">
                                                    Medicina, inclusive
                                                    laboratorial, e enfermagem
                                                </option>
                                                <option value="veterinaria">
                                                    Medicina veterinária
                                                </option>
                                                <option value="odontologia">
                                                    Odontologia e prótese
                                                    dentária
                                                </option>
                                                <option value="psicologia">
                                                    Psicologia, psicanálise,
                                                    terapia ocupacional,
                                                    acupuntura, podologia,
                                                    fonoaudiologia, nutrição,
                                                    vacinação e bancos de leite
                                                </option>
                                                <option value="comissaria">
                                                    Serviços de comissaria, de
                                                    despachantes, de tradução e
                                                    de interpretação
                                                </option>
                                                <option value="arquitetura">
                                                    Arquitetura e urbanismo
                                                </option>
                                                <option value="engenharia">
                                                    Engenharia, medição,
                                                    cartografia, topografia,
                                                    geologia, geodésia, testes,
                                                    suporte e análises técnicas
                                                    e tecnológicas, pesquisa,
                                                    design, desenho e agronomia
                                                </option>
                                                <option value="representacaoComercial">
                                                    Representação comercial e
                                                    demais atividades de
                                                    intermediação de negócios e
                                                    serviços de terceiros
                                                </option>
                                                <option value="pericia">
                                                    Perícia, leilão e avaliação
                                                </option>
                                                <option value="auditoria">
                                                    Auditoria, economia,
                                                    consultoria, gestão,
                                                    organização, controle e
                                                    administração
                                                </option>
                                                <option value="jornalismo">
                                                    Jornalismo e publicidade
                                                </option>
                                                <option value="agenciamento">
                                                    Agenciamento
                                                </option>
                                                <option value="atvIntelectual">
                                                    Outros serviços de natureza
                                                    intelectual, técnica,
                                                    científica, desportiva,
                                                    artística ou cultural
                                                </option>
                                                <option value="outra">
                                                    Minha atividade não está na
                                                    lista
                                                </option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className="mt-3">
                                    <Col md={12}>
                                        <Form.Group controlId="faturamento_mensal_medio">
                                            <Form.Label>
                                                Faturamento bruto mensal médio*
                                            </Form.Label>
                                            <MaskedInput
                                                className="form-control"
                                                mask={currencyMask}
                                                value={faturamento}
                                                onChange={(e) =>
                                                    setFaturamento(
                                                        e.target.value
                                                    )
                                                }
                                                placeholder="R$ 0,00"
                                                name="faturamento_mensal_medio"
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className="mt-3">
                                    <Col md={12}>
                                        <Form.Group
                                            controlId="proLabore"
                                            className="mb-3"
                                        >
                                            <Form.Label>
                                                Você recebe pró-labore?
                                            </Form.Label>
                                            <div>
                                                <Form.Check
                                                    type="radio"
                                                    label="Sim"
                                                    name="proLabore"
                                                    checked={proLabore === true}
                                                    onChange={() =>
                                                        setProLabore(true)
                                                    }
                                                />
                                                <Form.Check
                                                    type="radio"
                                                    label="Não"
                                                    name="proLabore"
                                                    checked={
                                                        proLabore === false
                                                    }
                                                    onChange={() =>
                                                        setProLabore(false)
                                                    }
                                                />
                                            </div>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                {proLabore && (
                                    <Row className="mt-3">
                                        <Col md={12}>
                                            <Form.Group controlId="valor_pro_labore">
                                                <Form.Label>
                                                    Valor do Pró-labore*
                                                </Form.Label>
                                                <MaskedInput
                                                    className="form-control"
                                                    mask={currencyMask}
                                                    value={valorProLabore}
                                                    onChange={(e) =>
                                                        setValorProLabore(
                                                            e.target.value
                                                        )
                                                    }
                                                    placeholder="R$ 0,00"
                                                    name="valor_pro_labore"
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                )}

                                <Row className="mt-3">
                                    <Col md={12}>
                                        <Form.Group
                                            controlId="temFuncionarios"
                                            className="mb-3"
                                        >
                                            <Form.Label>
                                                Você tem funcionários?
                                            </Form.Label>
                                            <div>
                                                <Form.Check
                                                    type="radio"
                                                    label="Sim"
                                                    name="temFuncionarios"
                                                    checked={
                                                        temFuncionarios === true
                                                    }
                                                    onChange={() =>
                                                        setTemFuncionarios(true)
                                                    }
                                                />
                                                <Form.Check
                                                    type="radio"
                                                    label="Não"
                                                    name="temFuncionarios"
                                                    checked={
                                                        temFuncionarios ===
                                                        false
                                                    }
                                                    onChange={() =>
                                                        setTemFuncionarios(
                                                            false
                                                        )
                                                    }
                                                />
                                            </div>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                {temFuncionarios && (
                                    <Row className="mt-3">
                                        <Col md={12}>
                                            <Form.Group controlId="folha_mensal">
                                                <Form.Label>
                                                    Gasto médio com folha de
                                                    pagamento mensal:
                                                </Form.Label>
                                                <MaskedInput
                                                    className="form-control"
                                                    mask={currencyMask}
                                                    value={gastoFolha}
                                                    onChange={(e) =>
                                                        setGastoFolha(
                                                            e.target.value
                                                        )
                                                    }
                                                    placeholder="R$ 0,00"
                                                    name="folha_mensal"
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                )}

                                <Row className="mt-3 text-center">
                                    <Col md={12}>
                                        <Button
                                            style={{ width: '75%' }}
                                            onClick={calcularFatorR}
                                        >
                                            Calcular Fator R
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>

                            {step === 'resultado' && (
                                <>
                                    <Row
                                        ref={sectionRef}
                                        className="mt-5"
                                        style={{ padding: '15px' }}
                                    >
                                        <h2 style={{ textAlign: 'center' }}>
                                            Seu Fator R atual é de{' '}
                                            {resultado.fatorR}%
                                        </h2>
                                        <p
                                            style={{
                                                color: '#1b53ad',
                                                fontSize: '1.6rem',
                                                fontWeight: 700,
                                                marginBottom: '20px',
                                            }}
                                            className="text-center"
                                        >
                                            Economize até{' '}
                                            {formatarParaReal(
                                                (resultado.economiaAnual/18)
                                            )}{' '}
                                            por ano em impostos!
                                        </p>

                                        <a
                                            href="https://www.contabilidadeolimpia.com.br/faleconoscocontato/"
                                            target="_blank"
                                            style={{
                                                textAlign: 'center',
                                                fontWeight: 700,
                                                color: '#fff',
                                                borderWidth: '0.5px',
                                                background: '#1b93c3',
                                                borderStyle: 'solid',
                                                padding: '10px 30px',
                                                borderRadius: 25,
                                            }}
                                        >
                                            Quero Pagar Menos Impostos
                                        </a>
                                    </Row>
                                </>
                            )}
                        </div>
                    </div>
                </Col>
                <Col sm={12} md={12} lg={4} style={{ marginBottom: '25px' }}>
                    <div
                        className="card main shadow-lg p-4 rounded custom-gradient"
                        style={{
                            background:
                                'linear-gradient(to bottom, #7cceee, #ffffff)',
                        }}
                    >
                        <h1>Abra seu CNPJ grátis com a Olímpia!</h1>
                        <div>
                            <p
                                className="text-center"
                                style={{
                                    marginBottom: '-10px',
                                    fontWeight: 600,
                                }}
                            >
                                Pague
                            </p>
                            <span
                                className="text-center"
                                style={{ fontSize: '40px', fontWeight: 700 }}
                            >
                                {' '}
                                SÓ AS TAXAS
                            </span>
                        </div>
                        <a
                            href="https://api.whatsapp.com/send?phone=5511968591004&text=Gostaria%20de%20abrir%20meu%20CNPJ"
                            style={{ marginTop: '20px', width: '100%' }}
                            target="_blank"
                            className="btn btn-primary"
                        >
                            QUERO SER PJ
                        </a>
                        <ul
                            style={{
                                listStyle: 'none',
                                textAlign: 'left',
                                marginTop: '20px',
                            }}
                        >
                            <li style={{ marginTop: '3px' }}>
                                <FontAwesomeIcon
                                    icon={faCheck}
                                    color="#1b93c3"
                                    size={25}
                                />{' '}
                                Contratando um de nossos planos de
                                contabilidade,{' '}
                                <b>a abertura do seu CNPJ é grátis</b>
                            </li>
                            <li style={{ marginTop: '3px' }}>
                                <FontAwesomeIcon
                                    icon={faCheck}
                                    color="#1b93c3"
                                    size={25}
                                />{' '}
                                <b>Otimizamos os impostos</b> do seu CNPJ para a
                                sua remuneração render.
                            </li>
                            <li style={{ marginTop: '3px' }}>
                                <FontAwesomeIcon
                                    icon={faCheck}
                                    color="#1b93c3"
                                    size={25}
                                />{' '}
                                Emita notas fiscais e acompanhe sua empresa{' '}
                                <b>24h por dia</b> na nossa plataforma
                            </li>
                            <li style={{ marginTop: '3px' }}>
                                <FontAwesomeIcon
                                    icon={faCheck}
                                    color="#1b93c3"
                                    size={25}
                                />{' '}
                                Escolha a forma de atendimento:{' '}
                                <b>WhatsApp, telefone, chat ou e-mail</b>
                            </li>
                            <li style={{ marginTop: '3px' }}>
                                <FontAwesomeIcon
                                    icon={faCheck}
                                    color="#1b93c3"
                                    size={25}
                                />{' '}
                                <b>Planos com assessor que entende sua área</b>{' '}
                                e emite suas notas fiscais
                            </li>
                            {/* <li style={{marginTop: '3px'}}><FontAwesomeIcon icon={faCheck} color="#1b93c3" size={25}/> Contrate <b>planos de saúde até 30% mais baratos do que os para pessoa física</b></li> */}
                        </ul>
                    </div>
                </Col>
            </Row>
            </div>

            <div className="bottom-cta-area">
                <div className="container">
                    <Row>
                        <Col xs={6} sm={6} md={6} lg={6}>
                            <div className="container container-cust">
                                <div style={{ display: 'flex' }}>
                                    <div
                                        className="hide-mobile"
                                        style={{ width: 100 }}
                                    >
                                        <FontAwesomeIcon
                                            icon={faLightbulb}
                                            color="#1b93c3"
                                            size="3x"
                                        />
                                    </div>
                                    <div
                                        className="hide-mobile"
                                        style={{
                                            textAlign: 'left',
                                            width: 200,
                                            color: '#414141',
                                        }}
                                    >
                                        Acessoria especializada no seu
                                        seguimento
                                    </div>
                                    <div
                                        className="cta-btn-area"
                                        style={{
                                            display: 'flex',
                                            flex: 2,
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <a
                                            target="_blank"
                                            href="https://www.contabilidadeolimpia.com.br/faleconoscocontato#nossos-planos"
                                            style={{
                                                fontWeight: 700,
                                                color: '#1b93c3',
                                                borderWidth: '0.5px',
                                                borderColor: '#1b93c3',
                                                borderStyle: 'solid',
                                                padding: '10px 30px',
                                                borderRadius: 25,
                                            }}
                                        >
                                            Conheça nossos planos
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col xs={6} sm={6} md={6} lg={6}>
                            <div className="container container-cust">
                                <div style={{ display: 'flex' }}>
                                    <div
                                        className="hide-mobile"
                                        style={{ width: 100 }}
                                    >
                                        <FontAwesomeIcon
                                            icon={faPhone}
                                            color="#1b93c3"
                                            size="3x"
                                        />
                                    </div>
                                    <div
                                        className="hide-mobile"
                                        style={{
                                            textAlign: 'left',
                                            width: 200,
                                            color: '#414141',
                                        }}
                                    >
                                        <span style={{ fontWeight: 600 }}>
                                            Dúvidas?
                                        </span>
                                        <br />
                                        Entre em contato
                                    </div>
                                    <div
                                        className="cta-btn-area"
                                        style={{
                                            display: 'flex',
                                            flex: 2,
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <a
                                            href="https://www.contabilidadeolimpia.com.br/faleconoscocontato/"
                                            target="_blank"
                                            style={{
                                                fontWeight: 700,
                                                color: '#fff',
                                                borderWidth: '0.5px',
                                                background: '#1b93c3',
                                                borderStyle: 'solid',
                                                padding: '10px 30px',
                                                borderRadius: 25,
                                            }}
                                        >
                                            Fale com um especialista
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </>
    );
};

export default CalculadoraRPA;
